import React, { useState, useEffect } from "react";
import { Source, Layer } from "react-map-gl";
import { calculateAzimuths } from "../DrawToolProvider/_draw.helpers";

const AzimuthLayer = ({ features }) => {
  const [azimuth_data, set_azimuth_data] = useState(null);

  useEffect(() => {
    const azimuthFeatures = Object.values(features).map((feature) => calculateAzimuths(feature));
    set_azimuth_data({
      type: "FeatureCollection",
      features: azimuthFeatures.flat(),
    });
  }, [features]);

  return (
    <>
      {azimuth_data && (
        <Source id={`azimuth-source`} type="geojson" data={azimuth_data}>
          <Layer
            id="azimuth-text-layer"
            type="symbol"
            layout={{
              "text-field": ["get", "azimuth"], //
              "text-size": 16,
              "text-font": ["Open Sans Bold"],
              //   "text-rotate": ["get", "bearing"],
              "text-offset": [0, ["case", ["==", ["get", "offsetDirection"], -1], -1, 1]],
              "symbol-spacing": 400,
              "text-allow-overlap": false,
              "text-keep-upright": true,
            }}
            paint={{
              //   "text-color": "rgba(0, 213, 231, 1)",
              "text-color": "#FFFFFF",
              "text-halo-color": "#000000",
              "text-halo-width": 1,
            }}
          />
        </Source>
      )}
    </>
  );
};

export { AzimuthLayer };
